var _circle, _circle2, _circle3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#E8FA7E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 45,
    cy: 45,
    r: 39,
    fill: "#E8FA7E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 32,
    fill: "#E8FA7E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4667 51.5333C33.7116 46.7783 31.6483 42.4191 31.1339 41.2119C31.0412 40.9942 31 40.7612 31 40.5246V36.7696C31 36.2392 31.2107 35.7305 31.5858 35.3554L34.527 32.4142C35.308 31.6332 36.5743 31.6332 37.3554 32.4142L41.37 36.4289C42.0442 37.103 42.1488 38.1592 41.6199 38.9525L39.8791 41.5637C39.481 42.1609 39.4321 42.9252 39.7829 43.5513C40.4031 44.658 41.4663 46.4074 42.5294 47.4706C43.5926 48.5337 45.342 49.5969 46.4487 50.2171C47.0748 50.5679 47.8391 50.519 48.4363 50.1209L51.0475 48.3801C51.8408 47.8512 52.897 47.9558 53.5711 48.63L57.5858 52.6446C58.3668 53.4257 58.3668 54.692 57.5858 55.473L54.6446 58.4142C54.2695 58.7893 53.7608 59 53.2304 59H49.4754C49.2388 59 49.0058 58.9588 48.7881 58.8661C47.5809 58.3517 43.2217 56.2884 38.4667 51.5333Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0b546178429617a6e5ed117362245460.svg";
export { ForwardRef as ReactComponent };